export default __webpack_public_path__ + "8b365ce35ec0eb4863bc08cba885c1f3.png";